export const firebaseConfig = {
  apiKey: 'AIzaSyC8J2voIvCd4DkB8J9u-l0ogfBub41LEcc',
  authDomain: 'block-vrock-1532736157223.firebaseapp.com',
  databaseURL: 'https://block-vrock-1532736157223.firebaseio.com',
  projectId: 'block-vrock-1532736157223',
  storageBucket: 'block-vrock-1532736157223.appspot.com',
  messagingSenderId: '683158767480',
  appId: '1:683158767480:web:6917ccb4c15951c1e5ea8d',
};
